// extracted by mini-css-extract-plugin
module.exports = {"s1c9ipa9":"s1c9ipa9"};